import Header from "components/Headers/Header";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Container,
} from "reactstrap";

const Consultas = () => {
  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <Col lg="12" md="12">
                <Card className="bg-secondary shadow border-0">
                  <CardBody className="px-lg-5 py-lg-5">
                    <div className="text-center text-muted mb-4">
                      <small>Consultar</small>
                    </div>
                    <Form role="form">
                      <FormGroup>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-lock-circle-open" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Seleccione tipo de búsqueda"
                            type="select"
                            autoComplete="new-password"
                          >
                            <option value="option1">
                              {" "}
                              Seleccione tipo de consulta
                            </option>
                            <option value="option1">Placa</option>
                            <option value="option2">Cilindro</option>
                            <option value="option3">Kit</option>
                            <option value="option3">Certificado</option>
                          </Input>
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-email-83" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input placeholder="diligencie" />
                        </InputGroup>
                      </FormGroup>

                      <div className="text-center">
                        <Button className="my-4" color="primary" type="button">
                          Buscar
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Consultas;
